import styled, { css } from 'styled-components';

import { ButtonBase, type Color } from '../ButtonBase';

import { type Size, Sizes } from './types';

type ButtonIconStyledProps = {
    $size?: Size;
    $color?: Color;
};

export const BUTTON_ICON_SIZE_MEDIUM_MOBILE = 40;
export const BUTTON_ICON_SIZE_MEDIUM_DESKTOP = 60;
const BUTTON_ICON_BREAKPOINT = 'mobile';

export const ButtonIconStyled = styled(ButtonBase)<ButtonIconStyledProps>`
    &&& {
        border-radius: 50%;
        flex: 0 0 auto;

        svg {
            display: inline-block;
            flex-shrink: 0;
            vertical-align: middle;
            max-width: 100%;
            overflow: hidden;
            fill: currentColor;
            box-sizing: border-box;
            width: 1em;
            height: 1em;
            user-select: none;
        }
        path {
            fill: inherit; // So we can change the color of the svg. Ideally the svg should not have fill property defined.
        }

        ${({ theme, $size, $color }) => {
            switch ($size) {
                case Sizes.large: {
                    return css`
                        height: 60px;
                        width: 60px;

                        svg {
                            font-size: 1.375rem;
                        }

                        @media (min-width: ${theme.breakpoints[BUTTON_ICON_BREAKPOINT]}) {
                            height: 80px;
                            width: 80px;

                            svg {
                                font-size: 2rem;
                            }
                        }

                        ${$color === 'primary' &&
                        css`
                            box-shadow:
                                0 0 8px ${theme.shades.purple[60]},
                                inset 0 0 16px ${theme.colors.purple};
                        `}
                    `;
                }
                case Sizes.medium: {
                    return css`
                        /* Button Component Figma Design is 44px */
                        height: ${BUTTON_ICON_SIZE_MEDIUM_MOBILE}px;
                        width: ${BUTTON_ICON_SIZE_MEDIUM_MOBILE}px;

                        svg {
                            /* font-size: 1.125rem; */
                            font-size: 0.9375rem;
                        }

                        @media (min-width: ${theme.breakpoints[BUTTON_ICON_BREAKPOINT]}) {
                            /* Button Component Figma Design is 56px */
                            height: ${BUTTON_ICON_SIZE_MEDIUM_DESKTOP}px;
                            width: ${BUTTON_ICON_SIZE_MEDIUM_DESKTOP}px;

                            svg {
                                /* font-size: 1.375rem; */
                                font-size: 1.125rem;
                            }
                        }

                        ${$color === 'primary' &&
                        css`
                            box-shadow:
                                0 0 8px ${theme.shades.purple[60]},
                                inset 0 0 16px ${theme.colors.purple};
                        `}
                    `;
                }
                case Sizes.small: {
                    return css`
                        height: 32px;
                        width: 32px;

                        svg {
                            font-size: 1rem;
                        }

                        @media (min-width: ${theme.breakpoints[BUTTON_ICON_BREAKPOINT]}) {
                            height: 40px;
                            width: 40px;
                        }

                        ${$color === 'primary' &&
                        css`
                            box-shadow:
                                0 0 8px ${theme.shades.purple[60]},
                                inset 0 0 8px ${theme.colors.purple};
                        `}
                    `;
                }
                case Sizes.smallMedium: {
                    return css`
                        height: 40px;
                        width: 40px;

                        svg {
                            font-size: 1.13rem;
                        }

                        @media (min-width: ${theme.breakpoints[BUTTON_ICON_BREAKPOINT]}) {
                            height: 48px;
                            width: 48px;
                        }

                        ${$color === 'primary' &&
                        css`
                            box-shadow:
                                0 0 8px ${theme.shades.purple[60]},
                                inset 0 0 8px ${theme.colors.purple};
                        `}
                    `;
                }
                case Sizes.extraSmall: {
                    return css`
                        height: 32px;
                        width: 32px;

                        svg {
                            font-size: 0.75rem;
                        }
                        @media (min-width: ${theme.breakpoints[BUTTON_ICON_BREAKPOINT]}) {
                            svg {
                                font-size: 0.875rem;
                            }
                        }

                        ${$color === 'primary' &&
                        css`
                            box-shadow:
                                0 0 8px ${theme.shades.purple[60]},
                                inset 0 0 8px ${theme.colors.purple};
                        `}
                    `;
                }
            }
        }}
    }
`;
